// Mulberry32 — deterministic seeded PRNG. Đủ chất lượng cho gameplay random
// (spawn lane, weighted pick), không phải crypto.
export class SeededRNG {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  next(): number {
    let t = (this.state += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  range(min: number, max: number): number {
    return min + this.next() * (max - min);
  }

  rangeInt(min: number, maxInclusive: number): number {
    return Math.floor(min + this.next() * (maxInclusive - min + 1));
  }

  pick<T>(arr: readonly T[]): T {
    if (arr.length === 0) throw new Error('SeededRNG.pick: empty array');
    const idx = Math.floor(this.next() * arr.length);
    return arr[idx] as T;
  }

  weightedPick<T>(items: ReadonlyArray<{ key: T; weight: number }>): T {
    if (items.length === 0) throw new Error('SeededRNG.weightedPick: empty items');
    const total = items.reduce((s, i) => s + i.weight, 0);
    let r = this.next() * total;
    for (const item of items) {
      r -= item.weight;
      if (r <= 0) return item.key;
    }
    return items[items.length - 1]!.key;
  }
}

export function generateSeed(): number {
  return Math.floor(Math.random() * 2 ** 32);
}
